import { CHAIN_IDS_TO_NAMES, defaultChainId, SupportedChainId } from 'config/chains'
import { useConnection } from 'hooks/useConnection'
import { useProtocolDataV2 } from 'hooks/useProtocolDayDatasV2'
import { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'
import { ExternalLink } from 'theme/components'
import { formatDollarAmount } from 'utils/formatDollarAmt'

import * as S from '../Liquidity.styles'
import { MobileLimitedHeaderTitle } from './IslandHeader'

export default function V2Header() {
  const theme = useContext(ThemeContext)
  const { chainId } = useConnection()
  const currentChainId = (chainId ?? defaultChainId()) as SupportedChainId
  const currentChainName = CHAIN_IDS_TO_NAMES[currentChainId]
  const { data: protocolDataV2, isLoading: isDataLoadingV2, isError: isDataErrorV2 } = useProtocolDataV2()

  return (
    <S.Header>
      <MobileLimitedHeaderTitle>
        <ThemedText.DeprecatedBody fontSize="18px" fontWeight="700">
          V2 Pools
        </ThemedText.DeprecatedBody>

        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="400" color={theme.textSecondary}>
          Provide liquidity in Kodiak v2 pools.
        </ThemedText.DeprecatedBody>

        <ExternalLink href="/#/explore/v2/pools" target="_self">
          Top V2 Pools ↗
        </ExternalLink>
      </MobileLimitedHeaderTitle>
      <S.HeaderBoxFlex>
        <S.HeaderBox>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" color={theme.textSecondary} lineHeight="14px">
            V2 TVL
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            {formatDollarAmount(protocolDataV2?.tvlUSD)}
          </ThemedText.DeprecatedBody>
        </S.HeaderBox>

        <S.HeaderBoxDesktop>
          <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" color={theme.textSecondary} lineHeight="14px">
            Volume
          </ThemedText.DeprecatedBody>

          <ThemedText.DeprecatedBody fontSize="20px" fontWeight="400" lineHeight="28px">
            {formatDollarAmount(protocolDataV2?.totalVolumeUSD)}
          </ThemedText.DeprecatedBody>
        </S.HeaderBoxDesktop>
      </S.HeaderBoxFlex>
    </S.Header>
  )
}
